<template>
    <div>
        <p class="feedback--question" v-text="$t('PAUSE_DELIVERIES_ANYTHING_BETTER')"/>
        <textarea class="input__textarea feedback--textarea" v-model="feedback"/>
        <button @click.prevent="submit" class="btn btn--primary btn--full-width confirm--button " v-text="ctaText"></button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import { CSPageEvents } from '@/helpers/GAHelpers';

let subscriptionService = new SubscriptionService();

export default {
    name: 'ConfirmationStep',
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        pauseSurveyAnswer: {
            type: Object,
        },
        stage: {
            type: String,
        },
    },
    data() {
        return {
            feedback: null,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    methods: {
        submit() {
            CSPageEvents(`${this.stage}-paused`);
            if (this.isPauseFlow) {
                let payload = {
                    reason: this.pauseSurveyAnswer?.label,
                    feedback: this.feedback,
                    resumeDate: null,
                };
                return subscriptionService.pauseSubscription(this.subscriptionId, payload)
                    .then(() => this.$emit('deliveries-paused'))
                    .catch(error => this.errorHandler.setResponse(error.response.data));
            }
            return subscriptionService.cancelSubscription(this.subscriptionId, this.pauseSurveyAnswer?.reason_id, this.feedback)
                .then(() => {
                    this.handleSubscriptionCancelled(this.subscriptionId);
                })
                .catch(error => {
                    this.errorHandler.setResponse(error.response.data);
                    this.$store.commit('account/setCanPauseOrCancel', false);
                    this.$router.go(-2);
                });
        },
        handleSubscriptionCancelled(subscriptionId) {
            let subscription = this.activeSubscriptions.filter(subscription => subscription.id !== subscriptionId)[0];
            this.$store.commit('subscription/setActiveSubscriptionId', subscription?.id);
            this.$emit('subscription-cancelled');
        },
    },
    computed: {
        ...mapGetters({
            isPauseFlow: 'account/getIsPauseFlow',
            activeSubscriptions: 'subscription/getActiveSubscriptions',
        }),
        ctaText() {
            return this.isPauseFlow ? this.$t('PAUSE_DELIVERIES_CONFIRM') : this.$t('CANCEL_DELIVERIES_CONFIRM');
        },
    },
};
</script>

<style lang="scss" scoped>

.feedback--question {
    margin: 24px 0 16px;
    text-align: left;
}

.feedback--textarea {
    font-size: 18px;
    line-height: 22px;
    padding: 8px 12px;
    height: 100px;
}

.confirm--button {
    margin: 54px 0 0;
    background: #262323;
    height: 40px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
}

</style>
